import { inject, Injectable } from '@angular/core'
import { ArchivesService } from '@app/generated/api/archives/archives.service'
import type { ArchivesBalzacBooksListParams } from '@app/generated/api/model'

@Injectable({
  providedIn: 'root',
})
export class BALZACBooksApi {
  private readonly archivesService = inject(ArchivesService)

  list (params: ArchivesBalzacBooksListParams) {
    return this.archivesService.balzacBooks(params)
  }
}
